import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import {
  SCHEDULE_CATEGORIES_TAB,
  SCHEDULE_SEND_TO_CALENDAR_TAB,
} from '../customizeOptions';
import { FullScreenPanel } from '../FullScreenPanel/FullScreenPanel';
import type { FullScreenSection } from '../FullScreenPanel/FullScreenPanel';
import { useCustomizeParams } from '../useCustomizeParams';
import { AddToCalendarSection } from './AddToCalendar/AddToCalendarSection';
import { CategoriesSection } from './Categories/CategoriesSection';
import { ScheduleDatesSection } from './ScheduleDatesSection';
import { TimeZoneSection } from './TimeZoneSection';

const SECTIONS: [FullScreenSection, ...FullScreenSection[]] = [
  {
    content: () => <TimeZoneSection />,
    icon: 'Globe',
    id: 'timezone',
    label: 'Time Zone',
  },
  {
    content: () => <CategoriesSection />,
    icon: 'Tag',
    id: SCHEDULE_CATEGORIES_TAB,
    label: 'Categories & Labels',
  },
  {
    content: () => <AddToCalendarSection />,
    icon: 'Calendar',
    id: SCHEDULE_SEND_TO_CALENDAR_TAB,
    label: 'Send to Calendar',
  },
];

const DATES_SECTION: FullScreenSection = {
  content: () => <ScheduleDatesSection />,
  icon: 'CalendarBlank',
  id: 'dates',
  label: 'Schedule Dates',
};

export const ScheduleSettingsPanel = () => {
  const { tab, setTab } = useCustomizeParams();
  const { value: scheduleDatesEnabled } = useFeatureFlag(
    'scheduleDatesEnabled'
  );

  const sections: [FullScreenSection, ...FullScreenSection[]] =
    scheduleDatesEnabled ? [...SECTIONS, DATES_SECTION] : SECTIONS;

  // The `tab` param drives the active section; fall back to the first section
  // (Time Zone) when it's absent or unrecognized.
  const activeId =
    tab != null && sections.some((s) => s.id === tab) ? tab : sections[0].id;

  return (
    <FullScreenPanel
      activeId={activeId}
      sections={sections}
      header={{
        highlight: 'whole schedule',
        icon: 'Settings',
        subtitlePrefix: 'Setup that applies to the ',
        subtitleSuffix: '.',
        title: 'Schedule Settings',
      }}
      onSelectSection={setTab}
    />
  );
};
